import * as React from 'react';

interface IOptionComponentProps {
  option: any;
  className: string;
  isFocused: boolean;
  onSelect: (option: any, event: React.MouseEvent<any>) => void;
  onFocus: (option: any, event: React.MouseEvent<any>) => void;
  children?: React.ReactNode;
}

export class OptionComponent extends React.Component<IOptionComponentProps> {
  public handleMouseDown = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  }

  public handleMouseEnter = (event: React.MouseEvent<any>) => {
    this.props.onFocus(this.props.option, event);
  }

  public handleMouseMove = (event: React.MouseEvent<any>) => {
    if (this.props.isFocused) {
      return;
    }

    this.props.onFocus(this.props.option, event);
  }

  public render() {
    const { children, className } = this.props;

    return (
        <div
            className={className + ' sessioncamhidetext'}
            onMouseDown={this.handleMouseDown}
            onMouseEnter={this.handleMouseEnter}
            onMouseMove={this.handleMouseMove}
        >
          {children}
        </div>
    );
  }
}

export const valueComponent: React.SFC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
      <div className="Select-value">
        <span className="Select-value-label sessioncamhidetext">{children}</span>
      </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/helpers/SessionCam.tsx